import { useState } from 'react'
import { useSelector } from 'react-redux'
import { ContactAddressType } from '../common/ContactAddress.type'
import { selectRole } from '../slices/authSlice'
import useIconInfo from './useIconInfo'

const useContactAddressCard = (contactAddress: ContactAddressType) => {
  const [isFavorite, setIsFavorite] = useState(
    contactAddress?.isFavorite || false,
  )

  const role = useSelector(selectRole)

  const { iconColor, iconSize } = useIconInfo()

  return {
    isFavorite,
    setIsFavorite,
    iconColor,
    role,
    iconSize,
  }
}

export default useContactAddressCard
